import { MyCompanyPanelBaseDataProvider } from './MyCompanyPanelBaseDataProvider';
import { CompanyData } from '../../../types/company-data';
import { User } from '../../../types/user';

export class MyCompanyPanelGzDataProvider extends MyCompanyPanelBaseDataProvider {
  public async getMyCompanyData(): Promise<CompanyData> {
    const record = await this.dependencies.api.clients.MyCompany.GetRecord().toPromise();

    if (!record || !record.data) {
      throw new Error('No my company data');
    }

    return record.data;
  }

  public async getLoggedUser(): Promise<User> {
    const user = await this.dependencies.api.clients.Users.GetLoggedUser().toPromise();

    if (!user) {
      throw new Error('No logged user data');
    }

    return user;
  }
}
